import { useContext } from "react";

import { GlobalContext } from "@clinic/shared/context/GlobalContext";
import type { GlobalConfig } from "@clinic/shared/data/globals/DefaultGlobals";

const useGlobalConfig = (): GlobalConfig => {
  const globalConfig = useContext(GlobalContext);

  return { ...globalConfig };
};

export { useGlobalConfig };
